import EADialog from "components/common/EADialog";
import i18next from "i18next";
import useStyles from "./CreditsafePanelStyle";
import { theme } from "style/globalStyle";

const InternationalScoreDetailsModal = ({ isOpen, onClose }) => {
    const { classes } = useStyles();

    return (
        <EADialog isOpen={isOpen} onClose={onClose} title={i18next.t("creditsafe.scores.internationalScore")} maxWidth="lg" hasActions={false}>
            <div className={classes.gridColumns}>

                <div className={classes.scoreDetailsContent}>
                    <span className={classes.internationalScoreBadge}
                        style={{ backgroundColor: "#2D9F40" }}>{"A"}</span>
                    <div className={classes.internationalScoreText}>
                        <span>{i18next.t("creditsafe.scoresValues.very_low.label")}</span>
                        <span style={{ color: theme.palette.grey.grey400 }}> {i18next.t("creditsafe.scoresValues.very_low.description")}</span>
                    </div>
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.internationalScoreBadge}
                        style={{ backgroundColor: theme.palette.primary.primary400 }}>{"B"}</span>
                    <div className={classes.internationalScoreText}>
                        <span>{i18next.t("creditsafe.scoresValues.low.label")}</span>
                        <span style={{ color: theme.palette.grey.grey400 }}>{i18next.t("creditsafe.scoresValues.low.description")}</span>
                    </div>
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.internationalScoreBadge}
                        style={{ backgroundColor: theme.palette.warning.warning500 }}>{"C"}</span>
                    <div className={classes.internationalScoreText}>
                        <span>{i18next.t("creditsafe.scoresValues.medium.label")}</span>
                        <span style={{ color: theme.palette.grey.grey400 }}>{i18next.t("creditsafe.scoresValues.medium.description")}</span>
                    </div>
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.internationalScoreBadge}
                        style={{ backgroundColor: theme.palette.error.error600 }}>{"D"}</span>
                    <div className={classes.internationalScoreText}>
                        <span>{i18next.t("creditsafe.scoresValues.high.label")}</span>
                        <span style={{ color: theme.palette.grey.grey400 }}>{i18next.t("creditsafe.scoresValues.high.description")}</span>
                    </div>
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.internationalScoreBadge}
                        style={{ backgroundColor: theme.palette.grey.grey400 }}>{"E"}</span>
                    <div className={classes.internationalScoreText}>
                        <span>{i18next.t("creditsafe.scoresValues.no_score.label")}</span>
                        <span style={{ color: theme.palette.grey.grey400 }}>{i18next.t("creditsafe.scoresValues.no_score.description")}</span>
                    </div>
                </div>
            </div>

        </EADialog>
    )

}
export default InternationalScoreDetailsModal;